import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const addCityFunc = createAsyncThunk(
    "addCity",
    async ({ data }, thunkAPI) => {
        try {
            const res = await api.post(`dashboard/cities`, data);
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || { message: error.message });
        }
    }
)
const addCitySlicer = createSlice({
    name: "addCity",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(addCityFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
        .addCase(addCityFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";
            })
        .addCase(addCityFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
});
export default addCitySlicer.reducer;